export const formatDateString = (date: string) => {
  const dateTimeFormat = new Intl.DateTimeFormat("en", {
    year: "numeric",
    month: "short",
    day: "2-digit",
    hour: "numeric",
    minute: "numeric",
    second: "numeric",
    hour12: false,
  });
  const [
    { value: month },
    ,
    { value: day },
    ,
    { value: year },
    ,
    { value: hour },
    ,
    { value: min },
    ,
    { value: second },
  ] = dateTimeFormat.formatToParts(new Date(date));
  return `${day}-${month}-${year} ${hour}:${min}:${second}`;
};
